import { type ReactNode } from 'react'

function SectionTitle({
	icon,
	children,
}: {
	icon: ReactNode
	children: ReactNode
}) {
	return (
		<div className="flex items-center gap-2 font-['EB_Garamond',ui-serif,Georgia] text-lg tracking-wide">
			<div className='border-border bg-card text-primary rounded-md border p-1'>
				{icon}
			</div>
			{children}
		</div>
	)
}

export { SectionTitle }
